export const resolveUrl = (url: string | null | undefined): string => {
    if (!url) return '';

    // Special handling for local development where absolute URLs might have wrong ports
    const isCustomerDoc = url.includes('/uploads/products/') && (url.includes('/POL-') || url.includes('/BAN-') || url.includes('/APP-'));
    const isProductImage = url.includes('/uploads/products/') && !isCustomerDoc;

    if (isCustomerDoc) {
        const pathOnly = url.substring(url.indexOf('/uploads/'));
        let customerUploadBase = process.env.REACT_APP_UPLOAD_BASE_URL || 'http://localhost:5227';
        return `${customerUploadBase.replace(/\/$/, '')}/${pathOnly.replace(/^\//, '')}`;
    }

    if (isProductImage) {
        const pathOnly = url.substring(url.indexOf('/uploads/'));
        let adminBase = (process.env.REACT_APP_API_BASE_URL || '').replace(/\/api\/.*$/, '');
        if (!adminBase) adminBase = 'http://localhost:5121';
        return `${adminBase.replace(/\/$/, '')}/${pathOnly.replace(/^\//, '')}`;
    }

    // If already a full URL, base64 data URI, or blob URL, return as-is
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:') || url.startsWith('blob:')) {
        return url;
    }
    if (url.startsWith('http//')) return url.replace('http//', 'http://');
    if (url.startsWith('https//')) return url.replace('https//', 'https://');

    // For relative paths (e.g. /uploads/products/xxx.jpg), resolve against the API server ORIGIN.
    // REACT_APP_UPLOAD_BASE_URL can be set explicitly (e.g. https://api.example.com).
    // Otherwise strip the /api/v1 (or similar) path from REACT_APP_API_BASE_URL to get just the origin.
    // Resolve against the API server origin (not the /api/v1 path)
    let uploadBase = process.env.REACT_APP_UPLOAD_BASE_URL
        || (process.env.REACT_APP_API_BASE_URL || '').replace(/\/api\/.*$/, '');

    // Auto-fix typo in environment variables on remote servers where colon is missing (e.g. https//api...)
    if (uploadBase.startsWith('http//')) uploadBase = uploadBase.replace('http//', 'http://');
    if (uploadBase.startsWith('https//')) uploadBase = uploadBase.replace('https//', 'https://');
    
    // Aggressively strip any /api path suffix that might have been accidentally included in UPLOAD_BASE_URL
    uploadBase = uploadBase.replace(/\/api\/.*$/, '');

    return `${uploadBase.replace(/\/$/, '')}/${url.replace(/^\//, '')}`;
};
